export default {
  //导航栏
  barmessage: {
    Home: "HOME",
    data: "DATA",
    About: "ABOUT",
    productService: "Product Service",
    cases: "Solution",
    news: "News",
    contactUs: "Contact Us",
    login: 'Login',
    report: 'Reports & Stats',
    LOGOtitle:'CPEOS International Data Node',
    LOGOtitleregion:'In Bangladesh'
  },

  queryboardmessage: { //查询面板
    polygon: "Polygon",
    nominatim: "Nominatim",
    producttype: "Product type",
    cloud: "Cloud Cover <",
    sensing: "Acquire Time",
    satellite: "Satellite Platform:",
    drawpolygon: 'Draw Polygon',
    drawrectangle: 'Draw Rectangle',
    clear: 'Clear',
    query: 'Query',
    cart: 'Toggle Cart',
    togglebutton: 'Toggle Query Panel',
    uploadfailed: 'Unsupported Data Format',
    uploadsuccessed: 'Successfully Uploaded Vector Data',
    uploadbutton: 'Upload Shpfile',
    uploadtitle: 'Vector Upload',
    upoladtip: 'Support shp files (. zip files, including. dbf,. shp,. prj files)'
  },

  querymapmessage: { //查询底图上的文字
    lonlat: 'Lon Lat:',
    fullscreen: 'Fullscreen',
    owslayername: 'World Administrative Divisions',
    satellitelayername: 'Satellite Imagery',
    worldlayername:'World Administrative Divisions',
    boundlayername:'Boundary',
    labellayername:'Annotation'
  },

  resultlistmessage: { //查询结果面板,部分与购物车面板共用
    satellite: 'Satellite',
    sensingdate: 'Sensing Date',
    online: 'Online',
    offline: 'Offline',
    display: 'Display {startindex} to {endindex} of {count} products',
    cartdisplay: 'Your Cart Contains { itemcount } products.',
    nofound: 'No products found',
    viewdata: 'View Product Details',
    zoomtodata: 'Zoom to Product',
    downloaddata: 'Download Product',
    tocart: 'Add Product to Cart',
    removecart: 'Remove Product from Cart',
    offlinewaring: 'Product Offline'
  },
  userprofilemessage: {
    edit: 'Edit Profile',
    logout: 'Logout',
    function: 'Allowed Functions',
    download: 'Download',
    search: 'Search'
  },
  fpmessage: { // 忘记密码面板

    title: 'Forgot Password',
    mess: 'Please fill this form to receive a link that will allow you to set a new password.',
    username: 'User name',
    usernameempty: 'User name empty',
    emailvalid: 'E-mail not valid',
    email: 'Email',
    send: 'SEND',
    errtitle: 'Retrieve Password Error',
    errmess: 'No user can be found for this username/email combination',
    succtitle: 'Retrieve Password Successful',
    succmess: 'An email was sent to you with instruction for resetting your password.'
  },
  rpmessage: { //重置密码面板
    title: 'Reset Password',
    mess: 'Please fill this form to reset your password.',
    passwdrule: ' Password field accepts only alphanumeric characters plus "!", "@", "#", "$", "%", "^", "&", "*", ")", "(", "+", "=", ".", "_", "-". Password fields minimum length is 8 characters. ',
    passwd: 'Password',
    emptypasswd: 'Empty password',
    passwdvalid: 'Password too short. Minimun 8 characters',
    confirmpasswdvalid: 'Password doesn\'t match ',
    confirmpasswd: 'Confirm password',
    send: 'Send',
    mbtitle1: 'Password Reset',
    mbresult1: ' Your password was successfully changed',
    mbresult2: ' There was an error while changing your password',
    mbtitle2: 'Password Reset Failed',

  },
  registmessage: { //注册面板
    title: "Register new account",
    header1: "Data access is free and open to all",
    notice1: 'On completion of the registration form below you will receive an e-mail with a link to validate your e-mail address. Following this you can start to download the data. Username field accepts only lowercase alphanumeric characters plus ".", "-" and "_". Password field accepts only alphanumeric characters plus "!", "@", "#", "$", "%", "^", "&", "*", ")", "(", "+", "=", ".", "_", "-". Password fields minimum length is 8 characters',
    firstname: "firstname",
    lastname: "lastname",
    username: "Username",
    passwd: 'Password',
    confirmpasswd: 'Confirm Password',
    company: 'Company/Institution/Agency Name',
    email: 'E-mail',
    confirmemail: 'Confirm E-mail',
    emailcheck: "E-mail not valid",
    emailmatch: "E-mail does not match",
    selectdomain: "Research Field",
    selecteducation:"Education",
    selectoccupation:"Occupation",
    selectusage: "Select Usage",
    selectcountry: "Select Country",
    register: "Register",
    shouquan: 'By registering in this website you are deemed to have accepted the T&C for GF data use'
  },
  editprofilemessage: { //编辑用户信息面板
    title: 'User {username} profile',
    firstname: "Firstname",
    firstnameempty: 'First Name Empty',
    lastnameempty: 'Last Name Empty',
    lastname: "Lastname",
    username: "Username",
    passwd: 'Password',
    confirmpasswd: 'Confirm Password',
    company: 'Company/Institution/Agency Name',
    email: 'E-mail',
    confirmemail: 'Confirm E-mail',
    emailcheck: "E-mail not valid",
    emailmatch: "E-mail does not match",
    selectdomain: "Research Field",
    selecteducation:"Education",
    selectoccupation:"Occupation",
    selectusage: "Select Usage",
    selectcountry: "Select Country",
    passwordalerm1: 'Please input the password',
    passwordalerm2: 'Password too short. Minimum 8 characters',
    oldpasswd: 'Please input old password',
    savemodification: 'Save Modification',
    passwdrule1: ' Password field accepts only alphanumeric characters plus "!", "@", "#", "$", "%", "^", "&", "*", ")", "(", "+", "=", ".", "_", "-". ',
    passwdrule2: 'Password fields minimum length is 8 characters.',
    changepasswd: 'Change Password'
  },
  loginmessage: { //登陆面板
    title: 'Please login to access our services...',
    username: 'Username',
    passwd: 'Password',
    loginbutton: 'LOGIN',
    signup: 'Sign up',
    fpasswd: 'Fogort Password?',
    passwderr: "The username and password you entered don't match or the user is not activated. ",
    loginsuccess: 'LOGIN SUCCESSFUL',
    logoutsuccess: 'LOGOUT SUCCESSFUL',
    usernotice:'Please note that this user account belongs to the CPEOS IDN system and is distinct from the CPEOS website system. You are required to log in using a dedicated account for the IDN service. New users can register here and need to pass the user country audit of the IDN system operator.',
    aboutuser:'*About User Account'
  },
  servicemessage: { //服务状态
    mess: 'The website is currently out of service '
  },

  downloadmessage: { //数据下载面板信息
    title: "Data Detailed Information",
    downloadmess: "Download Product",
    closemess: "Close",
    propertyname: 'Propertity Name',
    propertyvalue: 'Propertity Value',
    satellite: "Satellite:",
    sensor: "Instrument:",
    dataid: "Identifier:",
    image_start_time: "Sensing Date:",
    data_size: "Size(GB):",
    orbit_num: "Orbit Number",
    st_astext: "Footprint",
    productlevel: "Processing Level",
    cloud_cover: "Cloud Cover Percentage (%)",
    offline_flag: "Offline",
  },
  
  vdusermessage: { //激活用户
    title: '',
    success: 'Your account was successfully validated',
    failed: 'There was an error while validating your account'
  },
  gf1message: {

  },
  gf2message: {
    p1mess: ''
  },
  gf6message: {},
  reportmessage: {
    title: 'Statistics of all Data Hub Services since start of operations',
    RUsers:'Registered Users',
    download:'Users Downloads Volume',
    Productsnum:'Published Products',
    Availability:'Availability over the past Month'
  },
  indexmessage:{
    title1:'CPEOS International Data Node in Bangladesh',
    title2:'Access to Chinese Satellite Data over Bangladesh',
    title3:'Access More'
  }
};